import { useDebounceFn } from 'ahooks';
import { Radio } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { MultiTypeEnum, PartialSKU, SKU } from 'domains/skuDomain';
import { ChangeEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { QUANTITY_DEBOUNCE_MILLISECOND } from 'utils/constants';

type Props = {
  curItem: Partial<SKU>;
  updateCurItem: (item: PartialSKU) => Promise<void>;
};

export const DirectlyAddToCart = (props: Props) => {
  const { curItem, updateCurItem } = props;
  const { t } = useTranslation();
  const [description, setDescription] = useState<string>(
    curItem?.description || ''
  );
  const { run: updateMarkup, cancel: cancelUpdateMarkup } = useDebounceFn(
    async (e: ChangeEvent<HTMLTextAreaElement>) => {
      updateCurItem({
        ...curItem,
        description: e.target.value,
      });
    },
    { wait: QUANTITY_DEBOUNCE_MILLISECOND }
  );
  useEffect(() => {
    setDescription(curItem?.description || '');
  }, [curItem?.description]);
  return (
    <>
      <div
        className="multi-sku-detail-form-row"
        hidden={curItem?.multiType === MultiTypeEnum.PART}
      >
        <label>{t('platform.sku.form.label.directlyAddToCart')}:</label>
        <Radio.Group
          value={curItem?.preConfigured}
          disabled={curItem.readonly}
          onChange={(e) => {
            updateCurItem({
              ...curItem,
              preConfigured: e.target.value,
              description: e.target.value ? curItem?.description : '',
            });
          }}
        >
          <Radio value={true}>{t('common.yes')}</Radio>
          <Radio value={false}>{t('common.no')}</Radio>
        </Radio.Group>
      </div>
      <div hidden={!curItem?.preConfigured}>
        <div
          className="multi-sku-detail-form-row"
          style={{ marginBottom: 0 }}
          hidden={curItem?.multiType === MultiTypeEnum.PART}
        >
          <label>{t('platform.sku.form.label.skuDesctiption')}:</label>
        </div>
        <TextArea
          style={{ marginBottom: '24px' }}
          rows={4}
          // maxLength={INPUT_NORMAL_MAX_LENGTH}
          value={description}
          onChange={(e) => {
            setDescription(e.target.value);
            cancelUpdateMarkup();
            updateMarkup(e);
          }}
        />
      </div>
    </>
  );
};
